// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  width: 100%;
}

.ap-img {
  width: 100%;
}

.ap-wrap {
  position: relative;
}
.ap-wrap .overlay {
  position: absolute;
  width: 100%;
  height: 100%;
  inset: 0;
}

.map-text,
.tooltip-text {
  fill: black;
  text-anchor: middle;
  dominant-baseline: middle;
  pointer-events: none;
  white-space: pre-wrap;
  font-size: 20px;
  font-weight: bold;
}

.tooltip-text {
  font-size: 24px;
}

.map-text-bg,
.tooltip-text-bg {
  fill: white;
  pointer-events: none;
  filter: drop-shadow(2px 2px 4px rgba(0, 0, 0, 0.5)); /* Shadow */
}

.map-text-bg {
  rx: 4;
  ry: 4;
}

.tooltip-text-bg {
  rx: 8;
  ry: 8;
}

polygon {
  transition-property: fill, stroke;
  transition-duration: 300ms;
  transition-timing-function: ease-in-out;
}
polygon.has-link {
  cursor: pointer;
}
polygon.has-link:hover {
  fill: rgba(0, 128, 0, 0.7);
  stroke: rgba(0, 0, 0, 0.9);
  stroke-width: 6px;
}

.poly-wrapper .map-text,
.poly-wrapper .map-text-bg {
  opacity: 0;
  transition-property: opacity;
  transition-duration: 300ms;
  transition-timing-function: ease-in-out;
}
.poly-wrapper.not-available .map-text,
.poly-wrapper.not-available .map-text-bg {
  opacity: 1;
}
.poly-wrapper.not-available polygon {
  fill: rgba(221, 221, 221, 0.8);
  cursor: not-allowed;
  stroke-width: 6px;
}
.poly-wrapper.not-available polygon:hover {
  fill: rgba(255, 0, 0, 0.7);
  stroke: rgba(0, 0, 0, 0.9);
}
.poly-wrapper.not-available polygon.has-link {
  cursor: pointer;
}
.poly-wrapper:hover .map-text,
.poly-wrapper:hover .map-text-bg {
  opacity: 1;
}

.tooltip-wrapper {
  opacity: 0;
  transition-property: opacity;
  transition-duration: 300ms;
  transition-timing-function: ease-in-out;
}
.tooltip-wrapper.visible {
  opacity: 1;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
